// import { element, exact } from 'prop-types';
import { element } from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
// import contactUs from './views/pages/Privacy/contactUs'

const Dashboard = React.lazy(() => import('./views/dashboard/Dashboard'));
// const Inspection = React.lazy(() => import('./views/Add Stations/Inspection'))
const Templates = React.lazy(() => import('./views/templates/Templates'));
const ManageTemplates = React.lazy(() =>
   import('./views/templates/ManageTemplate'),
);
const ViewTemplates = React.lazy(() =>
   import('./views/templates/ViewTemplate'),
);
const Vechicles = React.lazy(() => import('./views/vechicles/Vechicles'));
const Settings = React.lazy(() => import('./views/settings/Settings'));
const Subscriptions = React.lazy(() =>
   import('./views/subscriptions/Subscriptions'),
);
const AddStations = React.lazy(() =>
   import('./views/Add Stations/AddStations'),
);
const Dealerships = React.lazy(() => import('./views/Dealerships/dealerships'));
const Uber = React.lazy(() => import('./views/Uber/uber'));
const Bookings = React.lazy(() => import('./views/Bookings/bookings'));
const Schedule = React.lazy(() => import('./views/Schedule/schedule'));
const AddServices = React.lazy(() =>
   import('./views/Add Services/AddServices'),
);
const Stations = React.lazy(() => import('./views/Stations/stations'));
const AddServicesAdmin = React.lazy(() =>import('./views/pages/ServiceStation/AddServicesAdmin'));
const ServiceList = React.lazy(() => import('./views/ServiceList/ServiceList'));
const EditServices = React.lazy(() =>
   import('./views/Add Services/EditServices'),
);
const ViewSchedule = React.lazy(() => import('./views/Schedule/ViewSchedule'));
const ScheduleList = React.lazy(() => import('./views/Schedule/ScheduleList'));
const Privacy = React.lazy(() => import('./views/pages/Privacy/privacy'));
const termOfUse = React.lazy(() => import('./views/pages/Privacy/termOfUse'));
const blog = React.lazy(() => import('./views/pages/Blog/Blog'));
const scheduleDetails = React.lazy(() =>
   import('./views/dashboard/ScheduleDetails'),
);
const StationDetails = React.lazy(() =>
   import('./views/dashboard/StationDetails'),
);
const scheduleDetailsForStation = React.lazy(() =>
   import('./views/dashboard/StationScheduleDetails/StationScheduleDetails'),
);
const GarageLeads = React.lazy(() => import('./views/Garage_Leads/Leads'));

// station Admin Routes
const adminRoutes = [
   {
      path: '/services-add',
      name: 'Add Services',
      element: AddServices,
      exact: true,
   },
   { path: '/settings', name: 'Settings', element: Settings, exact: true },
   { path: '/schedule', name: 'Schedule', element: Schedule, exact: true },
   {
      path: '/services-list',
      name: 'Services List',
      element: ServiceList,
      exact: true,
   },
   {
      path: '/services-edit',
      name: 'Edit Services',
      element: EditServices,
      exact: true,
   },
   {
      path: '/view-schedule',
      name: 'View Schedule',
      element: ViewSchedule,
      exact: true,
   },
   {
      path: '/schedule-list',
      name: 'Schedule List',
      element: ScheduleList,
      exact: true,
   },
   { path: '/dashboard', name: 'Dashboard', element: Dashboard },
   {
      path: '/dashboard/stationscheduledetails',
      name: 'Schedule Details',
      element: scheduleDetailsForStation,
      exact: true,
   },
   {
      path: '/addleads',
      name: 'Add Leads',
      element: GarageLeads,
      exact: true,
   },
];

// super Admin routes
const routes = [
   { path: '/', exact: true, name: 'Home' },
   { path: '/dashboard', name: 'Dashboard', element: Dashboard },
   { path: '/stations', name: 'Stations', element: Stations, exact: true },
   { path: '/add-services', name: 'Services', element: AddServicesAdmin, exact: true },
   {
      path: (
         <Link href="https://cms.inspectthiscar.com/admin/auth/login" passHref>
            <a target="_blank" rel="noopener noreferrer" />
         </Link>
      ),
      name: 'Write Blog',
   },
   {
      path: '/station-add',
      name: 'Add Station',
      element: AddStations,
      exact: true,
   },
   { path: '/templates', name: 'Templates', element: Templates, exact: true },
   {
      path: '/manage-templates',
      name: 'Manage Template',
      element: ManageTemplates,
      exact: true,
   },
   {
      path: '/view-templates',
      name: 'View Template',
      element: ViewTemplates,
      exact: true,
   },
   { path: '/vechicles', name: 'Vechicles', element: Vechicles, exact: true },
   { path: '/settings', name: 'Settings', element: Settings, exact: true },
   {
      path: '/subscriptions',
      name: 'Subscriptions',
      element: Subscriptions,
      exact: true,
   },
   // { path: '/individuals', name: 'Individuals', element: Individuals, exact: true },
   {
      path: '/dealerships',
      name: 'Dealerships',
      element: Dealerships,
      exact: true,
   },
   { path: '/uber', name: 'Uber', element: Uber, exact: true },
   {
      path: '/schedule',
      name: 'Appointment Schedule',
      element: Schedule,
      exact: true,
   },
   {
      path: '/services-add',
      name: 'Add Services',
      element: AddServices,
      exact: true,
   },

   {
      path: '/view-schedule',
      name: 'View Schedule',
      element: ViewSchedule,
      exact: true,
   },
   {
      path: '/schedule-list',
      name: 'Schedule List',
      element: ScheduleList,
      exact: true,
   },
   { path: '/privacy-policy', name: 'Privacy', element: Privacy, exact: true },
   {
      path: '/term-of-use',
      name: 'Terms of use',
      element: termOfUse,
      exact: true,
   },
   { path: '/blog', name: 'Blog', element: blog, exact: true },
   {
      path: '/dashboard/scheduledetails',
      name: 'Schedule Details',
      element: scheduleDetails,
      exact: true,
   },
   {
      path: '/dashboard/stationdetails',
      name: 'Station Details',
      element: StationDetails,
      exact: true,
   },
];

export { routes, adminRoutes };
